export const darktheme={
    colors:{
        primary: '#ffffff',
    },
    borderColors:{
        red:"#ff5757",
        blue:"#363d5d",
        purple:"#363d5d"
    }
}